
export default function getMyUpsolveEntryUrl() {


  return  `${UPSOLVE_FILER_URL}/bankruptcy-screener`|| "";
}
